import krysPhoto from "../assets/testimonial-krys-allen.png";
import tinaPhoto from "../assets/testimonial-tina-derby.png";
import kimPhoto from "../assets/testimonial-kim-hollandsworth.jpeg";

const testimonials = [
  {
    quote: "He handled both with skill and care.",
    name: "Krys Allen",
    role: "Agency Owner, Hello Dark Horse",
    image: krysPhoto,
    initials: "KA",
    link: "https://www.hellodarkhorse.com/",
    linkLabel: "View Krys's Site",
    context:
      "GHL login customization and live client migrations for an agency moving accounts without losing trust.",
  },
  {
    quote:
      "A great guy and a true computer geek, which is just what we want for this kind of work.",
    name: "Tina Derby",
    role: "Kristina Derby Consulting",
    image: tinaPhoto,
    initials: "TD",
    link: "https://kristinaderby.com/",
    linkLabel: "View Tina's Site",
    context:
      "Ongoing contractor support across AI-assisted web systems, Shopify maintenance, Supabase/Vercel builds, and Meta ad reporting.",
  },
  {
    quote: "Kind, patient, knowledgeable... a great problem solver.",
    name: "Kim Hollandsworth",
    role: "Aloha Riding Lessons",
    image: kimPhoto,
    initials: "KH",
    link: "https://aloharidinglessons.com/",
    linkLabel: "View Kim's Site",
    context:
      "Shopify and HighLevel support for an active service business that needed its web systems working smoothly.",
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials">
      <div className="testimonials__row">
        <div
          className="testimonials__intro"
          data-aos="fade-up"
          data-aos-anchor-placement="top-bottom"
        >
          <p className="testimonials__eyebrow">Client Proof</p>
          <h1 className="testimonials__title">Trusted Where Details Matter</h1>
          <p className="testimonials__desc">
            A few notes from real client work across websites, ecommerce
            cleanup, and business systems.
          </p>
        </div>

        <div className="testimonials__list">
          {testimonials.map((testimonial, index) => (
            <article
              className={`testimonial${
                testimonial.pending ? " testimonial--pending" : ""
              }`}
              key={testimonial.name}
              data-aos="fade-up"
              data-aos-delay={index * 100}
              data-aos-anchor-placement="top-bottom"
            >
              <div className="testimonial__media">
                {testimonial.image ? (
                  <img
                    src={testimonial.image}
                    alt={`${testimonial.name} testimonial`}
                    className="testimonial__image"
                  />
                ) : (
                  <div className="testimonial__image testimonial__image--fallback">
                    {testimonial.initials}
                  </div>
                )}
              </div>
              <p className="testimonial__quote">
                {testimonial.pending
                  ? testimonial.quote
                  : `"${testimonial.quote}"`}
              </p>
              <div className="testimonial__person">
                <div className="testimonial__avatar">
                  {testimonial.initials}
                </div>
                <div>
                  <h2 className="testimonial__name">{testimonial.name}</h2>
                  <p className="testimonial__role">{testimonial.role}</p>
                </div>
              </div>
              <p className="testimonial__context">{testimonial.context}</p>
              {testimonial.link && (
                <a
                  href={testimonial.link}
                  className="testimonial__link"
                  target="_blank"
                  rel="noreferrer"
                >
                  {testimonial.linkLabel}
                </a>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
